import { Typography } from '@mui/material';
import { useCallback } from 'react';

import { Mask, Pill } from '@hapvida/hapvida-core-components';

import { type BeneficiaryService } from '@services/BeneficiaryService';

import { BENEFICIARY_TYPE_COLOR, BENEFICIARY_TYPE_NAME } from '@constants';

import { BeneficiaryServiceRedirect } from '../components/BeneficiaryServiceRedirect';
import { BeneficiaryStatus } from '../components/BeneficiaryStatus';
import { BeneficiaryServicesColumnsEnum } from '../constants/columns';
import { type BeneficiaryServicesListRowsProps } from './types';

export function useBeneficiaryServicesListRows({
  beneficiaries,
}: BeneficiaryServicesListRowsProps) {
  const beneficiaryRow = useCallback(
    (beneficiary: BeneficiaryService) => ({
      [BeneficiaryServicesColumnsEnum.WALLET_NUMBER]: (
        <Typography variant="text">{beneficiary?.code ?? '-'}</Typography>
      ),
      [BeneficiaryServicesColumnsEnum.FULL_NAME]: (
        <Typography variant="text" fontWeight={'700'}>
          {beneficiary?.name ?? '-'}
        </Typography>
      ),
      [BeneficiaryServicesColumnsEnum.CPF]: (
        <Typography variant="text">
          {beneficiary?.document ? Mask.cpf(beneficiary?.document) : '-'}
        </Typography>
      ),
      [BeneficiaryServicesColumnsEnum.BIRTH_DATE]: (
        <Typography variant="text">{beneficiary?.birthDate ?? '-'}</Typography>
      ),
      [BeneficiaryServicesColumnsEnum.PLAN]: (
        <Typography variant="text">
          {beneficiary?.planHealthCode && beneficiary?.planHealthName
            ? `${beneficiary?.planHealthCode} - ${beneficiary?.planHealthName}`
            : '-'}
        </Typography>
      ),
      [BeneficiaryServicesColumnsEnum.STATUS]: (
        <BeneficiaryStatus status={beneficiary?.status ?? '-'} />
      ),
      [BeneficiaryServicesColumnsEnum.ACTIONS]: (
        <Typography variant="text">
          <BeneficiaryServiceRedirect
            name={beneficiary?.name}
            serviceAuthorized={beneficiary?.isServiceAuthorized}
            beneficiaryCode={beneficiary?.code}
          />
        </Typography>
      ),
    }),
    [],
  );

  const rows =
    beneficiaries
      .map((item, index) => {
        let mainRow = {};

        if (item) {
          mainRow = {
            ...beneficiaryRow(item),
            [BeneficiaryServicesColumnsEnum.TYPE]: (
              <Pill
                color={BENEFICIARY_TYPE_COLOR[item?.type]}
                text={BENEFICIARY_TYPE_NAME[item?.type]}
              />
            ),
          };

          const rowDataBeneficiary = {
            id: `${item?.code}-${index}`,
            itHasError: false,
            errorMessage: '',
            main: mainRow,
            dependents: [],
          };

          return rowDataBeneficiary;
        }

        return [];
      })
      .flat() ?? [];

  return { rows };
}
